/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plannamevereins3Inputs */

const en_plannamevereins3 = /** @type {(inputs: Plannamevereins3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club`)
};

const de_plannamevereins3 = /** @type {(inputs: Plannamevereins3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verein`)
};

/**
* | output |
* | --- |
* | "Club" |
*
* @param {Plannamevereins3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plannamevereins3 = /** @type {((inputs?: Plannamevereins3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plannamevereins3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plannamevereins3(inputs)
	return de_plannamevereins3(inputs)
});
export { plannamevereins3 as "planNameVereinS" }